import React, { useState } from 'react'
import { Zap, Shield, Globe, ChevronRight, Sparkles, ChevronLeft, ChevronRight as ChevronRightIcon } from 'lucide-react'
import { Link } from 'react-router-dom'

const Hero = () => {
  const [currentBrochurePage, setCurrentBrochurePage] = useState(0)
  const [touchStart, setTouchStart] = useState(0)
  const [touchEnd, setTouchEnd] = useState(0)
  const brochureImages = ['/brochure-1.jpg', '/brochure-2.jpg', '/brochure-3.jpg', '/brochure-4.jpg', '/brochure-5.jpg', '/brochure-6.jpg', '/brochure-7.jpg', '/brochure-8.jpg', '/brochure-9.jpg', '/brochure-10.jpg', '/brochure-11.jpg', '/brochure-12.jpg', '/brochure-13.jpg', '/brochure-14.jpg', '/brochure-15.jpg']

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX)
  }

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX)
  }

  const handleTouchEnd = () => {
    if (touchStart - touchEnd > 50) {
      setCurrentBrochurePage((prev) => (prev < brochureImages.length - 1 ? prev + 1 : 0))
    }
    if (touchEnd - touchStart > 50) {
      setCurrentBrochurePage((prev) => (prev > 0 ? prev - 1 : brochureImages.length - 1))
    }
  }

  const handleMouseDown = (e) => {
    setTouchStart(e.clientX)
  }

  const handleMouseMove = (e) => {
    setTouchEnd(e.clientX)
  }

  const handleMouseUp = () => {
    if (touchStart - touchEnd > 50) {
      setCurrentBrochurePage((prev) => (prev < brochureImages.length - 1 ? prev + 1 : 0))
    }
    if (touchEnd - touchStart > 50) {
      setCurrentBrochurePage((prev) => (prev > 0 ? prev - 1 : brochureImages.length - 1))
    }
  }
  return (
    <section className="min-h-screen pt-24 pb-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-violet-50 via-purple-50 to-pink-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center">
          <div className="inline-flex items-center px-5 py-2.5 rounded-full bg-gradient-to-r from-violet-100 to-purple-100 text-violet-700 text-sm font-semibold mb-8 shadow-sm border border-violet-200">
            <Sparkles size={16} className="mr-2" />
            AI智能陪伴 · 随时在线
          </div>
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-slate-900 mb-6 tracking-tight leading-tight">
            <span className="bg-gradient-to-r from-violet-600 via-purple-600 to-pink-600 bg-clip-text text-transparent">
              小乐悦AI陪伴智能体
            </span>
          </h1>
          <p className="text-xl sm:text-2xl text-slate-600 max-w-3xl mx-auto mb-12 leading-relaxed">
            您的贴心AI伙伴，24小时智能陪伴，聊天、学习、娱乐，让生活更有趣
          </p>
          
          <div className="flex flex-wrap justify-center gap-6 mb-16">
            <div className="flex items-center px-4 py-2 bg-white/80 backdrop-blur-sm rounded-xl shadow-sm border border-slate-200">
              <Shield size={20} className="mr-2 text-violet-600" />
              <span className="text-slate-700 font-medium">隐私保护</span>
            </div>
            <div className="flex items-center px-4 py-2 bg-white/80 backdrop-blur-sm rounded-xl shadow-sm border border-slate-200">
              <Globe size={20} className="mr-2 text-violet-600" />
              <span className="text-slate-700 font-medium">多语言支持</span>
            </div>
            <div className="flex items-center px-4 py-2 bg-white/80 backdrop-blur-sm rounded-xl shadow-sm border border-slate-200">
              <Zap size={20} className="mr-2 text-violet-600" />
              <span className="text-slate-700 font-medium">即时回复</span>
            </div>
          </div>

          <div className="mt-12 max-w-5xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              <Link to="/product-overview" className="group bg-white p-7 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-200 hover:border-violet-300 hover:-translate-y-1">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="w-12 h-12 bg-gradient-to-br from-violet-500 to-purple-600 rounded-xl flex items-center justify-center mb-4 shadow-lg">
                      <Sparkles className="text-white w-6 h-6" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-2">产品概述</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">了解产品基本信息与核心功能</p>
                  </div>
                  <ChevronRight className="text-violet-600 group-hover:translate-x-1 group-hover:text-violet-700 transition-all duration-300 flex-shrink-0 ml-4 mt-1" />
                </div>
              </Link>
              
              <Link to="/dialogue-features" className="group bg-white p-7 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-200 hover:border-violet-300 hover:-translate-y-1">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-rose-600 rounded-xl flex items-center justify-center mb-4 shadow-lg">
                      <Zap className="text-white w-6 h-6" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-2">对话功能</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">自然对话与情感陪伴</p>
                  </div>
                  <ChevronRight className="text-violet-600 group-hover:translate-x-1 group-hover:text-violet-700 transition-all duration-300 flex-shrink-0 ml-4 mt-1" />
                </div>
              </Link>
              
              <Link to="/music-features" className="group bg-white p-7 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-200 hover:border-violet-300 hover:-translate-y-1">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="w-12 h-12 bg-gradient-to-br from-purple-500 to-indigo-600 rounded-xl flex items-center justify-center mb-4 shadow-lg">
                      <Sparkles className="text-white w-6 h-6" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-2">音乐功能</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">音乐推荐与创作</p>
                  </div>
                  <ChevronRight className="text-violet-600 group-hover:translate-x-1 group-hover:text-violet-700 transition-all duration-300 flex-shrink-0 ml-4 mt-1" />
                </div>
              </Link>
              
              <Link to="/smart-features" className="group bg-white p-7 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-200 hover:border-violet-300 hover:-translate-y-1">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="w-12 h-12 bg-gradient-to-br from-blue-500 to-cyan-600 rounded-xl flex items-center justify-center mb-4 shadow-lg">
                      <Zap className="text-white w-6 h-6" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-2">智能功能</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">智能场景与个性化</p>
                  </div>
                  <ChevronRight className="text-violet-600 group-hover:translate-x-1 group-hover:text-violet-700 transition-all duration-300 flex-shrink-0 ml-4 mt-1" />
                </div>
              </Link>
              
              <Link to="/basic-operations" className="group bg-white p-7 rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-200 hover:border-violet-300 hover:-translate-y-1 md:col-span-2">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center mb-4 shadow-lg">
                      <Shield className="text-white w-6 h-6" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 mb-2">基础操作</h3>
                    <p className="text-slate-600 text-sm leading-relaxed">设备操作与指令参考</p>
                  </div>
                  <ChevronRight className="text-violet-600 group-hover:translate-x-1 group-hover:text-violet-700 transition-all duration-300 flex-shrink-0 ml-4 mt-1" />
                </div>
              </Link>
            </div>
          </div>

          <div className="mt-20 max-w-4xl mx-auto">
            <div className="relative">
              <div className="absolute -inset-1 bg-gradient-to-r from-violet-600 to-pink-600 rounded-3xl blur-lg opacity-30"></div>
              <div className="relative aspect-video bg-slate-900 rounded-2xl overflow-hidden shadow-2xl">
                <video 
                  controls 
                  autoPlay 
                  loop 
                  muted 
                  playsInline
                  className="w-full h-full object-cover"
                >
                  <source src="/abstract-video.mp4" type="video/mp4" />
                  您的浏览器不支持视频播放
                </video>
              </div>
            </div>
            <p className="mt-6 text-slate-500 text-base font-medium">
              产品简介视频 - 了解小乐悦AI陪伴智能体的核心功能
            </p>
          </div>

          <div className="mt-12 max-w-5xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="text-center">
                <h3 className="text-lg font-bold text-slate-900 mb-4">实验室宣传册</h3>
                <div 
                  className="relative aspect-[3/4] max-w-xs mx-auto bg-white rounded-xl overflow-hidden shadow-lg cursor-pointer select-none"
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                  onMouseDown={handleMouseDown}
                  onMouseMove={handleMouseMove}
                  onMouseUp={handleMouseUp}
                  onMouseLeave={handleMouseUp}
                >
                  {brochureImages.map((image, index) => (
                    <img
                      key={index}
                      src={image}
                      alt={`宣传册第${index + 1}页`}
                      className={`absolute inset-0 w-full h-full object-contain transition-all duration-500 ${
                        index === currentBrochurePage ? 'opacity-100 scale-100' : 'opacity-0 scale-95'
                      }`}
                    />
                  ))}
                  <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-2 bg-black/50 backdrop-blur-sm px-4 py-2 rounded-full">
                    <button
                      onClick={() => setCurrentBrochurePage((prev) => (prev > 0 ? prev - 1 : brochureImages.length - 1))}
                      className="text-white hover:text-violet-300 transition-colors disabled:opacity-30"
                      disabled={currentBrochurePage === 0}
                    >
                      <ChevronLeft size={24} />
                    </button>
                    <span className="text-white font-medium min-w-[60px] text-center">
                      {currentBrochurePage + 1} / {brochureImages.length}
                    </span>
                    <button
                      onClick={() => setCurrentBrochurePage((prev) => (prev < brochureImages.length - 1 ? prev + 1 : 0))}
                      className="text-white hover:text-violet-300 transition-colors disabled:opacity-30"
                      disabled={currentBrochurePage === brochureImages.length - 1}
                    >
                      <ChevronRightIcon size={24} />
                    </button>
                  </div>
                </div>
                <div className="mt-4 flex justify-center gap-2">
                  {brochureImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentBrochurePage(index)}
                      className={`w-2 h-2 rounded-full transition-all duration-300 ${
                        index === currentBrochurePage ? 'bg-violet-600 scale-125' : 'bg-slate-300'
                      }`}
                    />
                  ))}
                </div>
              </div>

              <div className="text-center">
                <h3 className="text-lg font-bold text-slate-900 mb-4">采购意向单</h3>
                <div className="relative aspect-[3/4] max-w-xs mx-auto bg-white rounded-xl overflow-hidden shadow-lg">
                  <img
                    src="/buying.png"
                    alt="上海音乐学院小乐悦采购意向单"
                    className="w-full h-full object-contain"
                  />
                </div>
                <p className="mt-4 text-slate-600 text-sm text-center">
                  上海音乐学院"小乐悦"采购意向单
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
